import { Formik, Form, Field, ErrorMessage } from 'formik';
import { forgotSchema } from './authSchemas';
import apiServices from '../../services/service';

const ForgotPassword = ({ onLogin }) => {
  return (
    <div className="loginBox">
      <Formik
        initialValues={{ email: '' }}
        validationSchema={forgotSchema}
        onSubmit={async (values) => {
          await apiServices.forgotPassword(values.email);
          alert('Reset link sent to your email');
          onLogin();
        }}
      >
        {({ errors, touched }) => (
          <Form className="login-card">
            <h2>Forgot Password</h2>

            <Field
              name="email"
              placeholder="Email"
              className={errors.email && touched.email ? 'errorField' : ''}
            />
            <ErrorMessage name="email" component="div" className="errorMessage" />

            <button type="submit" className="login-btn">
              Send Reset Link
            </button>
            <p className="signup-text">
              Already have an account?{' '}
              <span className="link" onClick={onLogin}>
                Login
              </span>
            </p>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ForgotPassword;
